import React, { useContext, useEffect, useState } from "react";
import { UsuarioContext } from "../../../providers/userContext";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import { Box, CircularProgress, InputLabel, FormControl, Autocomplete } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import { Select } from "@mui/material";
import { editarAAFF, getListadoAaffs, convertirAOficina, getLegaliaOptions } from "../../../services";
import Swal from 'sweetalert2';
import { useTranslation } from "react-i18next";
import {
  formatoFechas,
  municipiosIniciales,
  cambiarFormatoNombre,
} from "./../../../functions/funciones";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import { ordenarProvinciasYMunicipios } from "../../../functions/ordenarListas";
import {
  verificarCorreo,
  verificarTelefono,
  verificarFecha,
  verificarCodigoPostal,
} from "../../../functions/validator/formValidator";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85ch",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  zIndex: 1000,
};

const modal = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const paper = {
  backgroundColor: "#fff",
  border: "2px solid #000",
  boxShadow:
    "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
  padding: "16px 32px 24px",
};
const form = {
  margin: "8px",
  width: "100ch",
  position: "relative",
  display: "grid",
  gridTemplateColumns: " repeat(2, 1fr)",
  gridGap: "15px",
  fontSize: "12px",
};
export default function TransitionsModal(props) {
  const { t } = useTranslation(['aaff', 'common']);
  // let fechaEncargo = props.aaff.fechaEncargo === null ? null : formatoFechas(props.aaff.fechaEncargo)

  let fechaBienvenida =
    props.aaff.fechaBienvenida === null
      ? null
      : formatoFechas(props.aaff.fechaBienvenida);

  let fechaReclamacion =
    props.aaff.fechaReclamacion === null
      ? null
      : formatoFechas(props.aaff.fechaReclamacion);

  let fechaInforme =
    props.aaff.fechaInforme === null
      ? null
      : formatoFechas(props.aaff.fechaInforme);

  const navigate = useNavigate();
  const user = useContext(UsuarioContext);
  const [editarDatos, setEditarDatos] = useState({});
  const [listadoMunicipios, setListadoMunicipios] = useState([]);
  const [activo, setActivo] = useState(false);
  const [listadoAaffs, setListadoAaffs] = useState([]);
  const [padreSeleccionado, setPadreSeleccionado] = useState(null);
  const [legaliaOptions, setLegaliaOptions] = useState([]);

  useEffect(() => {
    const aaffData = {
      id: props.aaff.id,
      razonSocial: props.aaff.razonSocial,
      email: props.aaff.user?.email,
      nif: props.aaff.nif,
      nombreContacto: props.aaff.nombreContacto,
      correoContacto: props.aaff.correoContacto,
      telefono: props.aaff.telefono,
      municipio: props.aaff.municipio,
      provincia: props.aaff.provincia,
      codigoPostal: props.aaff.codigoPostal,
      // fechaEncargo: fechaEncargo,
      fechaBienvenida: fechaBienvenida,
      fechaReclamacion: fechaReclamacion,
      fechaInforme: fechaInforme,
      legalia_id: props.aaff.legalia_id ?? null,
      tieneLegalia: !!props.aaff.legalia_id,
      // comentarios: props.aaff.comentarios
    };
    setEditarDatos(aaffData);
    setListadoMunicipios(
      municipiosIniciales(provinces, municipalities, props.aaff.provincia)
    );
  }, [props]);

  useEffect(() => {
    getLegaliaOptions().then((opts) => setLegaliaOptions(opts || []));
  }, []);

  const handleLegaliaChange = (e) => {
    const value = e.target.value;
    const parsed = value ? parseInt(value, 10) : null;
    setEditarDatos((prev) => ({
      ...prev,
      legalia_id: parsed,
      tieneLegalia: parsed !== null,
    }));
  };

  function handleChange(evt) {
    const { name, value } = evt.target;
    setEditarDatos({
      ...editarDatos,
      [name]: value,
    });
  }

  const editar = (aaff) => {
    setActivo(true);
    const toastInfo = toast.info(t('messages.saving'), { autoClose: false });

    let data = {
      razonSocial: aaff.razonSocial,
      nif: aaff.nif,
      email: aaff.email,
      nombreContacto: aaff.nombreContacto,
      correoContacto: aaff.correoContacto,
      telefono: aaff.telefono,
      municipio: aaff.municipio,
      provincia: aaff.provincia,
      codigoPostal: aaff.codigoPostal,
      commer_id: aaff.commer_id,
      // fechaEncargo: aaff.fechaEncargo,
      fechaBienvenida: aaff.fechaBienvenida,
      fechaReclamacion: aaff.fechaReclamacion,
      fechaInforme: aaff.fechaInforme,
      tieneLegalia: !!aaff.tieneLegalia,
      legalia_id: aaff.tieneLegalia ? aaff.legalia_id ?? null : null,
      //comentarios: c
    };

    const validarCampos = () => {
      let errores = false;
      const requiredFields = ["razonSocial", "email"];

      requiredFields.forEach((field) => {
        if (!data[field]) {
          toast.error(t('messages.requiredField'));
          errores = true;
        }
      });

      Object.keys(data).forEach((key) => {
        switch (key) {
          case "email":
            if (data.email !== null && data.email !== "") {
              const correoCorrecto = verificarCorreo(data.email);
              if (!correoCorrecto) {
                toast.dismiss(toastInfo);
                toast.error(t('messages.incorrectEmail'));
                errores = true;
              }
            }
            break;
          // case "telefono":
          //   if (data.telefono !== null && data.telefono !== "") {
          //     const telefonoCorrecto = verificarTelefono(data.telefono);
          //     if (!telefonoCorrecto) {
          //       toast.dismiss(toastInfo);
          //       toast.error("El teléfono es incorrecto");
          //       errores = true;
          //     }
          //   }
          //   break;
          case "codigoPostal":
            if (data.codigoPostal !== null && data.codigoPostal !== "") {
              const codigoPostalCorrecto = verificarCodigoPostal(
                data.codigoPostal
              );
              if (!codigoPostalCorrecto) {
                toast.dismiss(toastInfo);
                toast.error(t('messages.incorrectPostalCode'));
                errores = true;
              }
            }
            break;
          // case "fechaEncargo":
          //   if (data.fechaEncargo !== null && data.fechaEncargo !=="") {
          //     const fechaEncargoCorrecto = verificarFecha(data.fechaEncargo);
          //     if (!fechaEncargoCorrecto) {
          //       toast.dismiss(toastInfo);
          //       toast.error("La fecha de Encargo no puede ser superior a la actual");
          //       errores = true;
          //     }
          //   }
          //   break;
          case "fechaBienvenida":
              // if (data.fechaBienvenida !== null && data.fechaBienvenida !== "") {
              //   const fechaBienvenidaCorrecto = verificarFecha(
              //     data.fechaBienvenida
              //   );
              //   if (!fechaBienvenidaCorrecto) {
              //     toast.dismiss(toastInfo);
              //     toast.error(
              //       "La fecha de Bienvenida no puede ser superior a la actual"
              //     );
              //     errores = true;
              //   }
              // }
            break;
          case "fechaReclamacion":
            if (
              data.fechaReclamacion !== null &&
              data.fechaReclamacion !== ""
            ) {
              // const fechaReclamacionCorrecto = verificarFecha(
              //   data.fechaReclamacion
              // );
              // if (!fechaReclamacionCorrecto) {
              //   toast.dismiss(toastInfo);
              //   toast.error(
              //     "La fecha de Reclamación no puede ser superior a la actual"
              //   );
              //   errores = true;
              // }
            }
            break;
          case "fechaInforme":
            if (data.fechaInforme !== null && data.fechaInforme !== "") {
              // const fechaInformeCorrecto = verificarFecha(data.fechaInforme);
              // if (!fechaInformeCorrecto) {
              //   toast.dismiss(toastInfo);
              //   toast.error(
              //     "La fecha del Informe no puede ser superior a la actual"
              //   );
              //   errores = true;
              // }
            }
            break;
          default:
            break;
        }
      });

      return errores;
    };

    // Salta solo cuando se activa LegalIA (null -> plan) y además aún no se ha notificado.
    const legaliaActivada =
      !props.aaff.legalia_id &&
      !!data.legalia_id &&
      !props.aaff.notificadoLegalIA;

    const enviarSolicitudCambio = () => {
      editarAAFF(props.aaff.nif, data)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            toast.update(toastInfo, {
              render: t('messages.editSuccess'),
              type: toast.TYPE.SUCCESS,
              autoClose: true,
            });
            if (legaliaActivada) {
              toast.info(t('messages.legaliaNotifyTomorrow', { defaultValue: 'Mañana el administrador recibirá por email el manual de uso de Legal IA.' }));
            }

            // Obtener la URL actual
            const urlActual = window.location.pathname + window.location.search;
            // Expresión regular para reemplazar solo el NIF en la parte correcta de la URL
            const nuevaUrl = urlActual.replace(
              new RegExp(`aaff/${props.aaff.nif}`),
              `aaff/${aaff.nif}`
            );
            // Cambiar la URL sin recargar la página
            navigate(nuevaUrl, { replace: true });

            props.handleClose();
          } else if (res.status === 403) {
            toast.update(toastInfo, {
              render: res.data.error[0],
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          } else {
            toast.update(toastInfo, {
              render: t('messages.editError'),
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          }
        })
        .catch((err) => {
          toast.update(toastInfo, {
            render: t('messages.editError'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
          console.log(err);
        })
        .finally(() => {
          setActivo(false);
        });
    };

    const errores = validarCampos();
    if (!errores) {
      enviarSolicitudCambio();
    } else {
      setActivo(false);
    }
  };

  const seleccionarMunicipios = (e) => {
    let codProvincia = "";
    let municipios = [];
    provinces.map((p) => {
      if (p.name === e.target.value) {
        codProvincia = p.code;
      }
    });
    setEditarDatos({
      ...editarDatos,
      [e.target.name]: e.target.value,
    });
    municipalities.map((m) => {
      if (m.provCode === codProvincia) {
        municipios.push({
          ...m,
          name: cambiarFormatoNombre(m.name),
          value: m.name,
        });
      }
    });
    setListadoMunicipios(municipios);
  };

  const handleClickConvertir = async () => {
    try {
      const response = await getListadoAaffs();

      if (!response || !Array.isArray(response)) {
        toast.error(t('convertToOffice.invalidResponse'));
        return;
      }

      const aaffsDisponibles = response.filter(a => a.nif !== props.aaff.nif);
      setListadoAaffs(aaffsDisponibles);
      mostrarModalSeleccionPadre(aaffsDisponibles);
    } catch (error) {
      console.error("Error al cargar AAFFs:", error);
      toast.error(t('convertToOffice.errorLoading') + ": " + (error.response?.data?.error || error.message));
    }
  };

  const mostrarModalSeleccionPadre = async (aaffsLista) => {
    props.handleClose();

    await new Promise(resolve => setTimeout(resolve, 100));

    const { value: formValues } = await Swal.fire({
      title: t('convertToOffice.title'),
      html: `
        <div style="text-align: left;">
          <label style="display: block; margin-bottom: 10px; font-weight: bold;">
            ${t('convertToOffice.enterNif')}
          </label>
          <input
            id="swal-input-nif-padre"
            class="swal2-input"
            placeholder="${t('convertToOffice.placeholder')}"
            style="width: 90%; margin: 0 auto; padding: 10px;"
          />
        </div>
      `,
      width: '500px',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: t('convertToOffice.convert'),
      cancelButtonText: t('common:actions.cancel'),
      confirmButtonColor: '#92004d',
      didOpen: () => {
        const input = document.getElementById('swal-input-nif-padre');
        setTimeout(() => input.focus(), 100);
      },
      preConfirm: () => {
        const nifPadre = document.getElementById('swal-input-nif-padre').value.trim().toUpperCase();

        if (!nifPadre) {
          Swal.showValidationMessage(t('convertToOffice.nifRequired'));
          return false;
        }

        const aaffExists = aaffsLista.find(aaff => aaff.nif.toUpperCase() === nifPadre);

        if (!aaffExists) {
          Swal.showValidationMessage(t('convertToOffice.nifNotFound', { nif: nifPadre }));
          return false;
        }

        return { nifPadre: aaffExists.nif };
      }
    });

    if (formValues) {
      convertirEnOficina(formValues.nifPadre);
    }
  };

  const convertirEnOficina = async (nifPadre) => {
    try {
      const toastLoading = toast.info(t('convertToOffice.converting'), { autoClose: false });

      const response = await convertirAOficina({
        nifHijo: props.aaff.nif,
        nifPadre: nifPadre
      });

      toast.dismiss(toastLoading);

      if (response.status >= 200 && response.status < 300) {
        toast.success(t('convertToOffice.success'));
        props.handleClose();
        window.location.reload();
      } else {
        toast.error(t('convertToOffice.error'));
      }
    } catch (error) {
      toast.error(t('convertToOffice.error'));
      console.error(error);
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={modal}
        open={props.opened}
        onClose={props.handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          style: { zIndex: 999 }
        }}
        style={{ zIndex: 1000 }}
      >
        <Box sx={style}>
          <div
            style={{
              backgroundColor: "#fff",
              border: "2px solid #000",
              boxShadow:
                "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
              padding: "16px 32px 24px",
            }}
          >
            <h2 id="transition-modal-title">{t('editModal.title')}</h2>
            <div id="transition-modal-description">
              <form noValidate autoComplete="off">
                <div
                  style={{
                    margin: "8px",
                    width: "100ch",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: " repeat(2, 1fr)",
                    gridGap: "15px",
                    fontSize: "12px",
                  }}
                >
                  {!props.aaff.parent_id && (
                    <TextField
                      variant="standard"
                      id="nif"
                      name="nif"
                      label={t('editModal.fields.nif')}
                      value={editarDatos.nif}
                      onChange={handleChange}
                    />
                  )}
                  <TextField
                    variant="standard"
                    id="razonSocial"
                    name="razonSocial"
                    label={t('editModal.fields.businessName')}
                    value={editarDatos.razonSocial}
                    onChange={handleChange}
                  />
                  <TextField
                    variant="standard"
                    id="email"
                    name="email"
                    label={t('editModal.fields.email')}
                    value={editarDatos.email}
                    onChange={handleChange}
                  />
                  <TextField
                    variant="standard"
                    id="nombreContacto"
                    name="nombreContacto"
                    label={t('editModal.fields.contact')}
                    minLength="3"
                    value={editarDatos.nombreContacto}
                    onChange={handleChange}
                  />
                  <TextField
                    variant="standard"
                    id="correoContacto"
                    name="correoContacto"
                    label={t('editModal.fields.contactEmail')}
                    value={editarDatos.correoContacto}
                    onChange={handleChange}
                  />
                  <TextField
                    variant="standard"
                    id="telefono"
                    name="telefono"
                    label={t('editModal.fields.phone')}
                    value={editarDatos.telefono}
                    onChange={handleChange}
                  />
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="provincia">{t('editModal.fields.province')}</InputLabel>
                    <Select
                      label={t('editModal.fields.province')}
                      variant="standard"
                      native
                      name="provincia"
                      id="provincia"
                      style={{ textTransform: "uppercase" }}
                      onChange={seleccionarMunicipios}
                      defaultValue={editarDatos?.provincia}
                    >
                      <option value=""></option>
                      {provinces
                        .sort(ordenarProvinciasYMunicipios)
                        ?.map((e, i) => {
                          return (
                            <option key={i} value={e.name}>
                              {e.name}
                            </option>
                          );
                        })}
                    </Select>
                  </FormControl>
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="municipio">{t('editModal.fields.municipality')}</InputLabel>
                    <Select
                      label={t('editModal.fields.municipality')}
                      variant="standard"
                      native
                      name="municipio"
                      id="municipio"
                      style={{ textTransform: "uppercase" }}
                      onChange={handleChange}
                      defaultValue={editarDatos?.municipio}
                    >
                      <option value=""></option>
                      {listadoMunicipios
                        .sort(ordenarProvinciasYMunicipios)
                        ?.map((e, i) => {
                          return (
                            <option key={i} value={e.value}>
                              {cambiarFormatoNombre(e.name)}
                            </option>
                          );
                        })}
                    </Select>
                  </FormControl>
                  <TextField
                    variant="standard"
                    id="codigoPostal"
                    name="codigoPostal"
                    label={t('editModal.fields.postalCode')}
                    value={editarDatos.codigoPostal}
                    onChange={handleChange}
                  />
                  {/* <TextField variant="standard" id="fechaEncargo" type="date" name="fechaEncargo" InputLabelProps={{ shrink: true }} label="Fecha Encargo" defaultValue={editarDatos.fechaEncargo} onChange={handleChange} /> */}
                  <TextField
                    variant="standard"
                    id="fechaBienvenida"
                    type="date"
                    name="fechaBienvenida"
                    InputLabelProps={{ shrink: true }}
                    label={t('editModal.fields.welcomeDate')}
                    defaultValue={editarDatos.fechaBienvenida}
                    onChange={handleChange}
                  />
                  <TextField
                    variant="standard"
                    id="fechaReclamacion"
                    type="date"
                    name="fechaReclamacion"
                    InputLabelProps={{ shrink: true }}
                    label={t('editModal.fields.claimDate')}
                    defaultValue={editarDatos.fechaReclamacion}
                    onChange={handleChange}
                  />
                  <TextField
                    variant="standard"
                    id="fechaInforme"
                    type="date"
                    name="fechaInforme"
                    InputLabelProps={{ shrink: true }}
                    label={t('editModal.fields.reportDate')}
                    defaultValue={editarDatos.fechaInforme}
                    onChange={handleChange}
                  />
                  <FormControl variant="outlined">
                    <InputLabel shrink htmlFor="legalia_id">Plan Legal IA</InputLabel>
                    <Select
                      label="Plan Legal IA"
                      variant="standard"
                      native
                      name="legalia_id"
                      id="legalia_id"
                      value={editarDatos.legalia_id ?? ""}
                      onChange={handleLegaliaChange}
                    >
                      <option value="">Sin Legal IA</option>
                      {legaliaOptions.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.nombre}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  {(user?.rol === "ADMIN" || user?.rol === "CONSUL" || user?.rol === "VENT") &&
                  <Button
                    className="btn-Secondary"
                    variant="contained"
                    color="primary"
                    onClick={handleClickConvertir}
                    style={{ marginTop: "8px", marginBottom: "8px" }}
                  >
                    {t('convertToOffice.title')}
                  </Button>
                  }
                </div>

                <div
                  style={{
                    margin: "8px",
                    width: "100ch",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: " repeat(2, 1fr)",
                    gridGap: "15px",
                    fontSize: "12px",
                  }}
                >
                  <Button
                    className="btn-Default"
                    variant="contained"
                    onClick={props.handleClose}
                    disabled={activo}
                    style={{ opacity: activo ? 0.6 : 1 }}
                  >
                    {t('common:actions.cancel')}
                  </Button>
                  <Button
                    className="btn-Secondary"
                    variant="contained"
                    color="secondary"
                    onClick={() => editar(editarDatos)}
                    disabled={activo}
                    style={{ opacity: activo ? 0.6 : 1, fontSize: '0.875rem' }}
                  >
                    {activo ? (
                      <CircularProgress
                        style={{ height: 20, width: 20, color: "#fff" }}
                      />
                    ) : (
                      <span style={{ fontSize: 'inherit' }}>{t('common:actions.edit')}</span>
                    )}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
